import { gql } from "@apollo/client";

// ============================================================================
// FOR-WHO QUERIES
// ============================================================================

import { GENERAL_FIELDS, SITE_FIELDS, PAGE_SETTINGS } from "./shared";
import {
  SECTIONS_WRAPPER_QUERY,
  TARGET_GROUP_FIELDS,
  FOR_WHO_OVERVIEW_META,
} from "./fragments/sections";
import { RELATED_CONTENT_SECTION_QUERY } from "./fragments/related-content";

// ============================================================================
// FOR-WHO FRAGMENTS
// ============================================================================

export const FOR_WHO_OVERVIEW_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${PAGE_SETTINGS}
  ${SECTIONS_WRAPPER_QUERY}
  ${RELATED_CONTENT_SECTION_QUERY}
  query GetForWho($locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: forWhoOverview(locale: $locale) {
      # For Who Overview Meta (SEO)
      _locales
      titles: _allTitleLocales {
        locale
        value
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # For Who Overview Fields (Content)
      title
      shortTitle
      intro {
        value
      }

      # For Who Overview Intro Image - Full Width (Landscape 1560x500) for ServiceHero
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
      # For Who Overview Intro Image - Square (500x500) for Hero when smallIntro is true
      introImageSquare: introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
      callToActions {
        ...ButtonBlock
        ...ButtonExternalBlock
        ...DownloadButtonBlock
        ...HubspotButtonBlock
      }

      # For Who Overview Components
      pageSettings {
        ...PageSettings
      }
      sections {
        ...SectionWrapperQuery
      }
      relatedContentSection {
        ...RelatedContentSectionQuery
      }
    }
    targetGroups: allTargetGroups(
      locale: $locale
      first: 100
      orderBy: _createdAt_DESC
      filter: { _locales: { allIn: [$locale] } }
    ) {
      ...TargetGroupFields
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }
    }
  }
`;

export const ALL_TARGET_GROUP_SLUGS_QUERY = gql`
  query GetAllTargetGroupSlugs($locale: SiteLocale!) {
    allTargetGroups(locale: $locale, first: 100) {
      slugs: _allSlugLocales(locale: $locale) {
        locale
        value
      }
    }
  }
`;

export const TARGET_GROUP_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${TARGET_GROUP_FIELDS}
  ${PAGE_SETTINGS}
  ${SECTIONS_WRAPPER_QUERY}
  ${RELATED_CONTENT_SECTION_QUERY}
  ${FOR_WHO_OVERVIEW_META}
  query GetTargetGroup($slug: String!, $locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    overview: forWhoOverview {
      ...ForWhoOverviewMeta
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: targetGroup(filter: { slug: { eq: $slug } }, locale: $locale) {
      # Target Group Meta (SEO)
      parent {
        slugs: _allSlugLocales(locale: $locale) {
          locale
          value
        }
        titles: _allTitleLocales(locale: $locale) {
          locale
          value
        }
      }
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      blockSearchIndexing

      # Target Group Fields (Content)
      ...TargetGroupFields
      preTitle

      callToActions {
        ...ButtonBlock
        ...ButtonExternalBlock
        ...DownloadButtonBlock
        ...HubspotButtonBlock
      }
      introImage {
        id
        responsiveImage(
          imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "500", h: "500", q: "75" }
        ) {
          alt
          height
          src
          title
          width
        }
      }

      pageSettings {
        ...PageSettings
      }
      sections {
        ...SectionWrapperQuery
      }
      relatedContentSection {
        ...RelatedContentSectionQuery
      }
    }
  }
`;
